module.exports = __webpack_public_path__ + "img/user.88c0e2ac.svg";